// removed by extract-text-webpack-plugin
module.exports = {"page":"_2Jni0gf396XkCzgj_3OmkM"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/LoginPage/style.css
// module id = 274
// module chunks = 0